export default __webpack_public_path__ + "static/media/chat_bot_image12.05428715.jpg";